module.exports = __webpack_public_path__ + "static/img/logoLogin.4fbda37c.png";